import {mapActions} from 'vuex';
import _ from 'lodash';
import productImage from './productImage';
import vSelect from 'vue-select';
import cartApi from '@support/cartApi';
import sendEventsMixin from '@mixins/sendEventsMixin';

export default {
  components: {vSelect, productImage},
  mixins: [sendEventsMixin],
  props: {
    product_id: {
      type: Number,
      required: true,
    },
    variant_id: {
      type: Number,
      required: false,
      default: null,
    },
    min_amount: {
      type: Number,
    },
    popupDisabled: {
      type: Boolean,
      default: false,
    },
    redirectToCheckoutWorkflow: {
      type: Boolean,
      default: false,
    },
    commentLabel: {
      type: String,
      default: null,
    },
  },
  data: function() {
    return {
      activeAccordionItem: 0,
      loading: true,
      addingToCart: false,
      afterAddMessage: null,
      product: {},
      variant: {},
      options: [],
      selectedOptions: {},
      disabledOptions: [],
      images: [],
      categories: [],
      selectedImageIndex: 0,
      variants: [],
      warehouses: [],
      selectedWarehouse: null,
      selectedVariant: {},
      variant_label: null,
      email: null,
      shipping_type: 'ship',
      comment: '',
      utm: {},
      showShare: false,
      addedToCartPopupVisible: false,
      notifiedPopupVisible: false,
      warehouseInfoPopupVisible: false,
      gift_card: {
        amount: this.min_amount || 0,
        email: null,
        message: null,
        first_name: null,
        last_name: null,
      },
      chart: {},
      sizeChartVisible: false,
      isCustomizeItem: false,
    };
  },
  computed: {
    isSilverCrystal() {
      return this.product.is_silver_crystal || false
    },
    isOptionsSelected() {
      return this.isAllOptionsSelected()
    },
    silverCrystalIframeSrc() {
      return this.selectedVariant.silver_crystal_iframe_src || ''
    },
    availableVariants() {
      const {variants} = this;

      return variants.map(e => e.values.data).
        flat().
        map(e => e.option.value_id).
        reduce((acc, n) => acc.includes(n) ? acc : [...acc, n], []).
        sort((a, b) => a - b);
    },
    isHasDiscount: function() {
      return !!this.product.is_has_discount
        || true === this.selectedVariant.is_has_discount;
    },
    currentImage: function() {
      if (!this.images.length) {
        return false;
      }

      return this.images[this.selectedImageIndex] || this.images[0];
    },
    shareBlockClasses: function() {
      if (!this.showShare) {
        return [];
      }

      return ['opened'];
    },
    isAddToCardDisabled: function() {
      if (true === this.product.is_comment_required && 0 ===
        this.comment.length) {
        return true;
      }
      if (!this.product.has_variants) {
        if (this.product.quantity <= 0) {
          return true;
        }
      } else if (!Object.entries(this.selectedVariant).length) {
        return true;
      } else if (_.isEmpty(this.selectedOptions)) {
        return true;
      } else {
        if (this.selectedVariant.quantity <= 0) {
          return true;
        }
      }

      return this.addingToCart || !!this.afterAddMessage ||
        !this.product.is_available;
    },
    message: function() {
      if (!this.product.is_available) {
        return 'Product is not available';
      } else if (!this.product.has_variants) {
        if (this.product.quantity < 5 && this.product.quantity > 0) {
          return `Only ${this.product.quantity} left`;
        } else if (this.product.quantity <= 0) {
          return 'Out of stock';
        }
      } else if (!Object.entries(this.selectedVariant).length) {
        return 'Out of stock';
      } else {
        if (this.selectedVariant.quantity < 5 && this.selectedVariant.quantity >
          0) {
          return `Only ${this.selectedVariant.quantity} left`;
        } else if (this.selectedVariant.quantity <= 0) {
          return 'Out of stock';
        }
      }

      return null;
    },
    productBlocks: function() {
      let result = [];

      if (this.product.description) {
        result.push({
          title: 'Description',
          content: this.product.description,
        });
      }

      if (this.product.shipping_description) {
        result.push({
          title: 'Shipping',
          content: this.product.shipping_description,
        });
      }

      if (this.product.details) {
        result.push({
          title: 'Details',
          content: this.product.details,
        });
      }

      if (this.product.tabs && this.product.tabs.data) {
        this.product.tabs.data.forEach((item) => {
          result.push({
            title: item.title,
            content: item.content,
          });
        });
      }

      return result;
    },
    isPickupAvailable: function() {
      return !_.isUndefined(this.product.warehouses) &&
        !_.isUndefined(this.product.warehouses.data) &&
        this.product.warehouses.data.length > 0 &&
        this.product.is_shippable_on_site &&
        this.product.is_available;
    },
    isPickupSelectVisible: function() {
      return 'pickup' === this.shipping_type &&
        this.warehouses.length > 0;
    },
    selectedWarehouseAddress: function() {
      return null !== this.selectedWarehouse
        ? this.selectedWarehouse.address
        : '';
    },
    selectedWarehouseDescription: function() {
      return null !== this.selectedWarehouse
        ? this.selectedWarehouse.description
        : '';
    },
    selectedWarehouseShippingDetailsLink() {
      return null !== this.selectedWarehouse
        ? this.selectedWarehouse.shipping_details_link
        : null;
    },
    isCommentEnabled: function() {
      return this.product.is_comment_enabled;
    },
    getCommentLabel: function() {
      let label = this.commentLabel;

      if (null === label) {
        label = 'Comment';
      }

      if (this.product.is_comment_required) {
        label += ' is required';
      }

      return label;
    },
    isProduct: function() {
      return !this.product.is_gift_certificate;
    },
    hasChart: function() {
      return this.chart && !_.isEmpty(this.chart);
    },
    oneClickCheckoutProductVariant() {
      const {utm, shipping_type, comment, variant} = this;

      if (!variant) {
        return null;
      }

      if (this.shipping_type === 'pickup' && this.selectedWarehouse) {
        variant.warehouse_id = this.selectedWarehouse.id;
      }
      return {
        ...variant,
        utm,
        shipping_type,
        comment,
      };
    },
    isOneClickCheckoutEnabled() {
      return !this.isAddToCardDisabled && this.isProduct &&
        this.isAllOptionsSelected() && this.isHasWarehouseSelected &&
        this.variant;
    },
    isHasWarehouseSelected() {
      return !('pickup' === this.shipping_type && null ===
        this.selectedWarehouse);
    },
    variantTotal() {
      return this.variant.quantity * this.product.price;
    },
    price() {
      return this.selectedVariant.price || this.product.price;
    },
    formattedPrice() {
      return this.selectedVariant.formatted_price ||
        this.product.formatted_price;
    },
    formattedDiscountPrice() {
      return this.selectedVariant.formatted_discount_price ||
        this.product.formatted_discount_price;
    },
    externalVideos() {
      return this.product?.externalVideos?.data || [];
    },
    videos() {
      return this.product?.videos?.data || [];
    },
  },
  mounted() {
    this.setCampaignValues();
    this.loadProduct();
  },
  methods: {
    ...mapActions('cart', [
      'loadCheckout',
    ]),
    closeModal() {
      this.isCustomizeItem = false
    },
    setCampaignValues: function() {
      const campaignKeys = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content'];
      const queryParams = qs.parse(this.$route.query);

      campaignKeys.forEach((value) => {
        if (queryParams[value]) {
          this.utm[value] = queryParams[value];
        }
      });
    },
    loadProduct: function() {
      axios.get(`/api/v1/products/${this.product_id}`).then(r => {
        this.product = r.data.data;
        this.images = this.product.images.data || [];
        this.categories = this.product.categories.data || [];
        this.options = this.product.options.data || [];
        this.selectedOptions = {};
        this.variant = {
          product_id: this.product.id,
          quantity: 1,
          sku: null,
          variant_id: 0,
        };
        this.warehouses = this.product.warehouses.data || [];
        this.chart = this.product.chart.data || {};
        this.loadVariants();
        this.setWarehouse();
        this.sendImpression();
        this.onProductLoaded(this.product.title);

        document.dispatchEvent(new CustomEvent('productViewed', { detail: { product: r.data.data }}));

      }).catch(e => console.error(e.message)).then(() => {
        this.productImagesAlt();
      }).finally(() => {
        this.loading = false;
      });
    },
    loadVariants: function() {
      axios.get(`/api/v1/products/${this.product.id}/variants`).then(r => {
        this.variants = r.data.data;
        this.setVariant();
      }).catch(e => console.error(e.message));
    },
    updateSelectedVariant: function() {
      if (!this.isAllOptionsSelected()) {
        return;
      }

      this.variant.sku = this.selectedVariant.sku || this.product.sku;
      this.variant.quantity = 1;

      this.loadProductVariant();
      console.log('update selected variant');
    },
    loadProductVariant: function() {
      const productId = this.product.id || this.product_id;
      let params = [];
      Object.keys(this.selectedOptions).forEach((value) => {
        params.push({
          id: value,
          value_id: this.selectedOptions[value],
        });
      });

      axios.get(`/api/v1/products/${productId}/variants`, {
        params: {options: params},
        paramsSerializer: function(params) {
          return qs.stringify(params, {arrayFormat: 'indices'});
        },
      }).then(response => {
        this.updateProduct(response.data);
      }).catch(error => {

      });
    },
    updateProduct: function(responseData) {
      this.variant.variant_id = this.variant_id || 0;
      this.variant.quantity = 1;
      this.selectedVariant = {};

      if (responseData.data.length) {
        this.variant.variant_id = responseData.data[0].id;
        this.selectedVariant = responseData.data[0];
        if (responseData.data[0].images.data.length > 0) {
          this.images = responseData.data[0].images.data;
        }
      }
    },
    updateProductCount: function(count) {
      if (this.product.has_variants) {
        if (!this.selectedVariant.quantity) {
          return;
        }
        if (count + this.variant.quantity === 0 || count +
          this.variant.quantity > this.selectedVariant.quantity) {
          return;
        }

        this.variant.quantity += count;
      } else {
        if (count + this.variant.quantity === 0 || count +
          this.variant.quantity > this.product.quantity) {
          return;
        }

        this.variant.quantity += count;
      }

    },
    addToCart: function() {
      if (this.isProduct) {
        this.addProductToCart();
      } else {
        this.addGiftCardToCart();
      }
    },
    addProductToCart: function() {
      if (!this.isAllOptionsSelected()) {
        alert('Select all options before add product to cart');

        return;
      }

      if ('pickup' === this.shipping_type && null === this.selectedWarehouse) {
        alert('Select warehouse you want to pickup product from');

        return;
      }

      if (this.isAddToCardDisabled) {
        return;
      }

      if ('pickup' === this.shipping_type) {
        this.variant['warehouse_id'] = this.selectedWarehouse.id;
      }

      this.addingToCart = true;
      this.variant['utm'] = this.utm || [];
      this.variant['shipping_type'] = this.shipping_type;
      this.variant['comment'] = this.comment || '';

      cartApi.addToCart(this.variant).then((response) => {
        document.dispatchEvent(new CustomEvent('productAddedToCart', { detail: { response: response.data }}));

        try {
          let object = {
            'id': this.product.sku || this.product.id,
            'name': this.product.title,
            'quantity': this.variant.quantity,
            'price': this.price,
            'list': 'Product Page',
            'brand': this.product.vendor_name,
            'category': this.product.main_category_title,
          };

          if (this.isHasDiscount) {
            object.price = this.product.discount_price;
          }

          if (this.variant.sku) {
            object['variant'] = this.variant.sku;
          }

          window.ga('ec:addProduct', object);
          window.ga('ec:setAction', 'add');
          window.ga('send', 'event', 'UX', 'click', 'add to cart');
          window.ga('send', 'pageview');
          this.onProductAddedToCart(this.product.title);
        } catch (ex) {
          console.error('unable add impression', ex);
        }
        this.resetSelection();
        this.afterAddMessage = 'Added To Cart';

        setTimeout(() => {
          this.afterAddMessage = null;
        }, 2000);

        this.addedToCartPopupVisible = true;
      }).catch(error => {
        console.error(error);

        if (_.has(error, 'response.data.message')) {
          this.afterAddMessage = error.response.data.message;
        } else {
          this.afterAddMessage = 'Product Not Added';
        }

        setTimeout(() => {
          this.afterAddMessage = null;
        }, 2000);
      }).then(() => {
        this.addingToCart = false;
        this.loadCheckout();
        this.handleRedirectToCheckoutWorkflow();
      });
    },
    addGiftCardToCart: function() {
      this.$nextTick(() => this.$validator.validate().then(valid => {
        if (!valid) {
          const first_error = this.$validator.errors.items[0].field;

          if (first_error) {
            this.$scrollTo(`[name="${first_error}"]`);
          }
          return;
        }

        const request = {
          gift_card: this.gift_card,
          quantity: this.variant.quantity,
          utm: this.utm || [],
        };

        this.addingToCart = true;
        axios.post(`/api/v1/cart/add-gift-card`, request).then(() => {
          this.afterAddMessage = 'Added To Cart';

          setTimeout(() => {
            this.afterAddMessage = null;
          }, 2000);

          this.addedToCartPopupVisible = true;
        }).catch(error => {
          console.error(error);

          console.log(error.response);

          if (_.has(error, 'response.data.message')) {
            this.afterAddMessage = error.response.data.message;
          } else {
            this.afterAddMessage = 'Product Not Added';
          }

          setTimeout(() => {
            this.afterAddMessage = null;
          }, 2000);
        }).then(() => {
          this.addingToCart = false;
          this.loadCheckout();
          this.handleRedirectToCheckoutWorkflow();
        });
      }));
    },
    resetSelection: function() {
      this.variant.quantity = 1;
    },
    setVariant: function() {
      let selectedVariant;

      if (this.variant_id && this.variants.length > 0) {
        selectedVariant = this.variants.filter(
          variant => variant.id === this.variant_id)[0] || null;
      }

      if (!selectedVariant &&
        Object.keys(this.product.defaultVariant.data).length > 0) {
        selectedVariant = this.product.defaultVariant.data;
      }

      if (!selectedVariant) {
        return;
      }

      this.variant.sku = selectedVariant.sku || null;
      this.variant.variant_id = selectedVariant.id || 0;

      if (Object.keys(selectedVariant).length === 0) {
        this.options.forEach((value) => {
          this.selectedOptions[value.id] = 0;
        });
      }

      selectedVariant.values.data.forEach((item) => {
        this.selectedOptions[item.option.id] = item.option.value_id;
      });

      if (selectedVariant.images.data.length) {
        this.images = selectedVariant.images.data;
      }
      this.updateSelectedVariant();
    },
    setWarehouse: function() {
      if (this.warehouses.length > 0) {
        this.selectedWarehouse = this.warehouses[0];
      }
    },
    isAllOptionsSelected: function() {
      const unselectedOptions = Object.keys(this.selectedOptions).
        filter((key) => {
          return this.selectedOptions[key] === 0;
        });

      return unselectedOptions.length === 0;
    },
    showOption(id, valueId) {
      return this.availableVariants.includes(valueId)
    },
    isOptionAvailableForSelected(id, val) {
      const {variants} = this;
      const sel = Object.keys(this.selectedOptions).map(id => ({
        id: Number(id),
        value_id: this.selectedOptions[id],
      }));

      if (id === 4 || id === 1) {
        return true;
      }

      if (!variants.length || !sel) {
        return false;
      }

      const el = variants.map(e => e.values.data.map(e => e.option));
      const selectedOptions = sel.filter(e => e.id !== id);
      const partlyEqObj = (a, b) => Object.keys(a).
        map(key => b[key] === a[key]).
        every(e => e === true);
      const getObjInArray = (a, b) => b.filter(e => partlyEqObj(a, e));
      const availableOptions = el.filter(
        e => selectedOptions.map(obj => getObjInArray(obj, e).length > 0).
          every(e => e === true));
      return availableOptions.flat().
        filter(e => e.id === id).
        map(e => e.value_id).
        includes(val);
    },
    isOptionEnabled: function(optionValue) {
      return optionValue.variants_quantity > 0 || optionValue.quantity > 0 ||
        this.variants.includes(optionValue.id);
    },
    isOptionSelected: function(optionId, optionValueId) {
      return (typeof this.selectedOptions[optionId] !== 'undefined') &&
        (this.selectedOptions[optionId] === optionValueId);
    },
    getAccordionClass: function(index) {
      return (this.activeAccordionItem === index ? 'opened' : null);
    },
    toggleAccordionItem: function(index) {
      if (this.activeAccordionItem === index) {
        this.activeAccordionItem = null;
      } else {
        this.activeAccordionItem = index;
      }

    },
    notifyInStock: function() {
      this.$validator.validate().then((valid) => {
        if (!valid) {
          const first_error = this.$validator.errors.items[0].field;

          if (first_error) {
            this.$scrollTo(`[name="${first_error}"]`);
          }
          throw new Error();
        }

        return axios.post(`/api/v1/products/${this.product.id}/notify`, {
          email: this.email,
        });
      }).then(() => {
        this.notifiedPopupVisible = true;
        this.email = null;
      }).catch(error => {
        console.error(error);

        if (_.has(error, 'response.data.message')) {
          this.afterAddMessage = error.response.data.message;
        } else {
          this.afterAddMessage = 'Notification error';
        }

        setTimeout(() => {
          this.afterAddMessage = null;
        }, 2000);
      });
    },
    showWarehouseInfo: function() {
      if (null !== this.selectedWarehouse) {
        this.warehouseInfoPopupVisible = true;
      }
    },
    sendImpression() {
      try {
        let object = {
          'id': this.product.sku || this.product.id,
          'name': this.product.title,
          'category': this.product.main_category_title,
          'price': this.product.price,
          'list': 'Product Page',
          'brand': this.product.vendor_name,
          'position': 1,
        };

        if (this.isHasDiscount) {
          object.price = this.product.discount_price;
        }

        window.ga('ec:addImpression', object);
        window.ga('ec:setAction', 'detail');
        window.ga('send', 'pageview');
      } catch (e) {
        console.error('unable send tracking data');
      }
    },
    productImagesAlt() {
      this.$nextTick(() => {
        let $productImages = document.querySelector('.product__image'),
          $normalImage = $productImages.querySelector('img.normal'),
          $zoomImage = $productImages.querySelector('img.zoom');
        if (document.body.contains($productImages) && $normalImage &&
          $zoomImage) {
          $normalImage.setAttribute('alt', this.product.title + ' Image');
          $zoomImage.setAttribute('alt', this.product.title + ' Zoomed Image');
          $normalImage.setAttribute('title', this.product.title + ' Image');
          $zoomImage.setAttribute('title', this.product.title + ' Zoomed Image');
        }
      });
    },
    handleRedirectToCheckoutWorkflow() {
      if (!this.redirectToCheckoutWorkflow) {
        return false;
      }

      window.location.href = '/checkout';
    },
    focus(selector) {
      const elToFocus = document.querySelector(selector);

      if (elToFocus && typeof elToFocus.focus === 'function') {
        elToFocus.focus();
      }
    },
  },
};
